exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-undergrad-projects-js": () => import("./../../../src/pages/undergrad-projects.js" /* webpackChunkName: "component---src-pages-undergrad-projects-js" */)
}

